import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredAdvisorId } from '../../utils/advisorNetworkConstants';

const AdvisorComposeGuard = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const advisorId = getStoredAdvisorId(user);
  if (!advisorId) {
    return <Navigate to="/advisor-network" replace />;
  }

  return children;
};

export default AdvisorComposeGuard;
